/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiMembership } from './Membership';

export interface AccountTransactionRequest {

    /**
     * The ID of the transaction
     */
    id?: number;

    created_at?: string;

    /**
     * Description of the transaction
     */
    description?: string;

    /**
     * Category of the transaction
     */
    transaction_category?: string;

    /**
     * Type of the transaction
     */
    transaction_type?: string;

    /**
     * Source of the transaction
     */
    transaction_source?: string;

    /**
     * Method of the transaction
     */
    transaction_method?: string;

    /**
     * Whether the transaction failed or not
     */
    failed?: boolean;

    /**
     * Failure code
     */
    failure_code?: string;

    /**
     * Failure message
     */
    failure_message?: string;

    /**
     * The amount of money involved in this transaction, in cents (USD)
     */
    price?: number;

    /**
     * The discount given for this transaction, in cents (USD)
     */
    discount?: number;

    source_timestamp?: string;

    membership?: ApiMembership;

}

@Model('AccountTransaction')
export class ApiAccountTransaction extends BaseModel implements AccountTransactionRequest {

    /**
     * The ID of the transaction
     */
    
    
    id: number;

    
    
    created_at: string;

    /**
     * Description of the transaction
     */
    
    
    description: string;

    /**
     * Category of the transaction
     */
    
    
    transaction_category: string;

    /**
     * Type of the transaction
     */
    
    
    transaction_type: string;

    /**
     * Source of the transaction
     */
    
    
    transaction_source: string;

    /**
     * Method of the transaction
     */
    
    
    transaction_method: string;

    /**
     * Whether the transaction failed or not
     */
    
    
    failed: boolean;

    /**
     * Failure code
     */
    
    
    failure_code: string;

    /**
     * Failure message
     */
    
    
    failure_message: string;

    /**
     * The amount of money involved in this transaction, in cents (USD)
     */
    
    
    price: number;

    /**
     * The discount given for this transaction, in cents (USD)
     */
    
    
    discount: number;

    
    
    source_timestamp: string;

    @Type('ApiMembership')
    @Expand()
    membership: ApiMembership;

}
